module.exports = __webpack_public_path__ + "img/3Dian5_9.9bd597c3.png";